import i18n from "@/i18n";

export function formatApiError(err, fallback = i18n.t("errors.generic", { ns: "common" })) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((e) => (typeof e === "string" ? e : e?.msg))
      .filter(Boolean)
      .map((m) => m.replace(/^Value error,\s*/i, ""));
    if (msgs.length) return msgs.join(" • ");
  }
  return fallback;
}
